import { queryPremiumRateForCIES as queryPremiumRate } from 'core/service/rider/query-premium-rate'
import { calculateRiderPremiumForCIES as calculateRiderPremium } from 'core/service/rider/premium-calculation'
import { queryTaxRateForCIES as queryTaxRate } from 'core/service/rider/query-tax-rate'

export default {
  calculateRiderPremium,
  queryPremiumRate,
  queryTaxRate,
}
